const defaultConstants = {
    defaultPassword1: 'password@123',
    defaultPassword2: 'test@123',
    defaultPassword3: 'Test@123',
    loginAttemptsExceed: 'Login Attempts Exceeded',
    resetYourPasswordToContinue: 'Reset your password to continue',
    defaultPasswordEncryptedValue: '8dcb583b3ba5aa22850f93db0eec4c2a076d2cce',
    defaultPasswordEncryptedValue1: '8e7152d0eb52c340579f2d70a28eaf1a2c5ba1c5',
    defaultPasswordEncryptedValue2: '91fd5c87f3de6a5a735c87093b3ac207cd99facb',
    defaultPasswordEncryptedValue3: '719855e8f4ebd94341277b0b0d50b75c5187133f',
    consigneeRegex: "/^(consignee-[a-zA-Z]+.+[a-zA-Z].in)$/",
};
const eInvoiceAccessConfig = {
    username: 'testeway@mastersindia.co',
    password: '!@#Demo!@#123',
    client_id: 'fIXefFyxGNfDWOcCWnj',
    client_secret: 'QFd6dZvCGqckabKxTapfZgJc',
    grant_type: 'password',
  };
module.exports = {
    defaultConstants,
    eInvoiceAccessConfig
};